import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "About the Diploma", "id": "about-diploma" },
    { "name": "Functions & Objectives", "id": "functions-objectives" },
    { "name": "Time Table", "id": "timetable" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>Pourohitya (priesthood) and Karmakanda (rituals) are important parts of Indian religious and cultural traditions. Teaching this subject at the university level has several significant aspects. The study of Pourohitya and Karmakanda is not limited to religious rituals, but it is also the basis of culture, society, and individual spiritual advancement. At the university level, this subject combines traditional knowledge with modern research to provide new energy to Sanatana traditions.</p>
            <p>Vedic Karmakanda holds a significant place in Sanatana Dharma and many other spiritual traditions. It is a collection of various religious rituals, yagnas, pujas, and samskaras (sacraments) that help purify and balance an individual's spiritual, mental, and social life. It is extremely important for the economic, social, and mental upliftment of society.</p>
        </>
    ),
    "functions-objectives": (
        <>
            <h5>Functions & Objectives</h5>
            <h6>Preservation of Scriptures and Traditions</h6>
            <ul>
                <li>In-depth study of Vedic texts, Puranas, Smritis, and Samhitas.</li>
                <li>Development of scientific and philosophical understanding of Vedic mantras, Yajna methods, samskaras, and rituals.</li>
                <li>Work on preserving and advancing the traditions of Sanatana Dharma.</li>
            </ul>

            <h6>Creation of Authentic and Trained Priests</h6>
            <ul>
                <li>Instruction on correct pronunciation, methods, and procedures is given to avoid inaccuracies.</li>
                <li>Intensive training in religious rituals and samskaras is provided, so that society can get qualified priests.</li>
            </ul>

            <h6>Practical Utility for Society</h6>
            <ul>
                <li>Knowledge of pure and effective methods for samskaras like marriage, upanayana (sacred thread ceremony), shraddha (ancestral rites), and yajna is imparted.</li>
                <li>The role of trained priests is crucial in religiously educating society.</li>
            </ul>

            <h6>Employment and Career Opportunities</h6>
            <ul>
                <li>Career paths can be forged as certified priests, religious teachers in the Indian Army, Sanskrit teachers, astrologers, researchers, religious writers, Vedic reciters, etc.</li>
                <li>At universities, Karmakanda is studied not just traditionally, but also from scientific and historical perspectives.</li>
                <li>Understanding is developed to harmonize traditions with modern technology (online rituals, digital religious services).</li>
            </ul>
        </>
    ),
    "timetable": (
        <>
            <p>Content not available.</p>
        </>
    ),
    "achievements": (
        <>
            <p>Content not available.</p>
        </>
    ),
    "contact": (
        <>
            <p>Dr. Harish Kumar, Coordinator</p>
            <p>Karmakanda/Pourohitya Diploma</p>
            <p>Phone – 79883-76657</p>
        </>
    )
};

export default function KarmakandaPourohityaDiploma_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);
    const [activeId, setActiveId] = useState(departments[0].id);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId]);
        setActiveId(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">Karmakanda/Pourohitya Diploma</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id
                                ? "bg-primary text-white"
                                : "bg-white text-dark"
                                }`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <h5>Main Content</h5>
                <div>{currentContent}</div>
            </main>
        </div>
    );
}